import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import SearchBar from '../SearchBar';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Meetings() {
    const [meetings, setMeetings] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;

    const fetchMeetings = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/getMeetings.php`);
            setMeetings(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching meetings:', error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMeetings();
    }, []);

    const handleSearch = (value) => {
        setSearchTerm(value);
        setCurrentPage(0);
    };

    const filteredMeetings = meetings.filter((meeting) =>
        Object.values(meeting).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const pageCount = Math.ceil(filteredMeetings.length / itemsPerPage);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <div>
            <h2>Meetings</h2>
            <div className="search-bar">
                <SearchBar onSearch={handleSearch} />
            </div>
            {isLoading ? (
                <p>Loading meetings...</p>
            ) : (
                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>Meeting ID</th>
                                <th>User</th>
                                <th>Tutor</th>
                                <th>Date</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMeetings
                                .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
                                .map((meeting) => (
                                    <tr key={meeting.meetingId}>
                                        <td>{meeting.meetingId}</td>
                                        <td>{meeting.userName}</td>
                                        <td>{meeting.tutorName}</td>
                                        <td>{meeting.meetingDate}</td>
                                        <td>{meeting.meetingTime}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    <ReactPaginate
                        previousLabel={<FaChevronLeft />}
                        nextLabel={<FaChevronRight />}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        forcePage={currentPage}
                    />
                </div>
            )}
        </div>
    );
}

export default Meetings;
